import type { TagShelf, TagShelfCategory } from "../services/tags.service.ts";

export interface ShelfFilterOption {
  value: string;
  label: string;
  count?: number;
}

export interface ShelfFilterState {
  shelfOptions: ShelfFilterOption[];
  shelfTagMap: Map<string, string[]>;
}

export const resolveShelfLabel = (category: TagShelfCategory) =>
  [category.name, category.slug, category.id].map(value => value?.trim() ?? "").find(Boolean) ?? "";

export const getShelfTagIds = (shelf: TagShelf) => {
  const raw = shelf.tagIds?.length ? shelf.tagIds : shelf.category?.id ? [shelf.category.id] : [];
  return Array.from(new Set(raw.filter(Boolean)));
};

export const buildShelfStashesSearchParams = (shelf: TagShelf) => {
  const params = new URLSearchParams();
  const shelfTitle = resolveShelfLabel(shelf.category);
  if (shelfTitle) {
    params.append("group", shelfTitle);
  }
  getShelfTagIds(shelf).forEach(tagId => {
    params.append("tag", tagId);
  });
  return params;
};

export const buildShelfStashesHref = (shelf: TagShelf, stashesPath: string) => {
  const query = buildShelfStashesSearchParams(shelf).toString();
  return query ? `${stashesPath}?${query}` : undefined;
};

export const buildShelfFilterState = (shelves: TagShelf[] | null | undefined): ShelfFilterState => {
  const shelfOptions: ShelfFilterOption[] = [];
  const shelfTagMap = new Map<string, string[]>();

  for (const shelf of shelves ?? []) {
    const label = resolveShelfLabel(shelf.category);
    if (!label) continue;
    const tagIds = getShelfTagIds(shelf);
    if (tagIds.length === 0) continue;
    shelfOptions.push({ value: label, label, count: shelf.postCount });
    shelfTagMap.set(label, tagIds);
  }

  return { shelfOptions, shelfTagMap };
};
